<!-- eslint-disable i18next/no-literal-string -->
<template>
  <mc-confirmation 
    :value="true" 
    title="Batal"
    message="Status DO-001 akan berbuah dari Dikonfirmasi -> Dibatalkan" 
    body-title="Batalkan Pengiriman?"
    ok-title="Hapus"
    @handle-ok="handleOk()"
  >
    <div class="form-group">
      <label for="exampleInputEmail1">Alasan Pembatalan</label>
      <input type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp">
      <small id="emailHelp" class="form-text text-muted"><span class="text-danger">*</span> <span class="fst-italic">Mandatory</span></small>
    </div>
  </mc-confirmation>
</template>
<script>
  import McConfirmation from './index.vue'
export default {
  components: {
    McConfirmation
  }
}
</script>